export default __webpack_public_path__ + "static/media/img2.601eb131.jpg";